import Colors from 'constants/Colors';

export default {
  container: {
    display: 'flex',
    padding: 32,
    flexDirection: 'column',
  },
  whiteBackground: {
    backgroundColor: 'white',
    width: '100%',
    borderRadius: 14,
    padding: 14,
    minHeight: '70vh',
    marginBottom: 32,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16,
    gap: 16,
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  datePicker: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${Colors.lightGray}`,
  },
  header: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  alertStyle: {
    marginBottom: '10px',
    color: '#721c24',
    padding: '10px 20px',       
    borderRadius: '5px',        
    fontFamily: 'Arial, sans-serif', 
    fontSize: '14px',
    textAlign: 'center',        
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', 
  },
  TextContainer: {
    color: Colors.black,
    fontFamily: 'Arial, sans-serif',
  },
  popOverStyle:{
    color: Colors.yellowButton,
    marginRight: 8,
    padding: 4,
    border: `1px solid ${Colors.yellowButton}`,
    borderRadius: 2,
    fontSize: 20,
    marginLeft: 10
  }
};
